module.exports = __webpack_public_path__ + "media/images/city/043-national-mall-fff202298db71b452afe147b5c8ca824.svg";